import { Location } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { TipologiaRegistrazioneApiClient } from '@ideapa/app-api-client';
import {
  BaseSharedEntityEffects,
  SharedEntityActions,
} from '@ideapa/app-base-components';
import { NgrxLoaderFacade } from '@ideapa/app-ngrx-loader';
import { RouterFacade } from '@ideapa/app-routing-utils';
import { ToastService } from '@ideapa/app-ui-kit';
import { Actions } from '@ngrx/effects';

import { ENTITY_NAME_TOKEN, SHARED_ENTITY_ACTIONS_TOKEN } from './constants';
import { TipologiaRegistrazione as Entity } from './models';
import { State } from './reducer';

@Injectable()
export class EntityEffects extends BaseSharedEntityEffects<Entity, State> {
  constructor(
    actions$: Actions,
    service: TipologiaRegistrazioneApiClient,
    loaderFacade: NgrxLoaderFacade,
    toastService: ToastService,
    location: Location,
    routerFacade: RouterFacade,
    @Inject(ENTITY_NAME_TOKEN) entityName: string,
    @Inject(SHARED_ENTITY_ACTIONS_TOKEN)
    actions: SharedEntityActions<Entity>
  ) {
    super(
      actions$,
      service,
      loaderFacade,
      toastService,
      location,
      routerFacade,
      entityName,
      actions
    );
  }
}
